/* eslint-disable i18next/no-literal-string */
// src/components/errors/ErrorDashboardHeader.jsx
import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Badge,
  ToggleButtonGroup,
  ToggleButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import {
  BugReport as BugReportIcon,
  Refresh as RefreshIcon,
  FilterList as FilterIcon,
  CleaningServices as CleanupIcon,
  Dashboard as DashboardIcon,
  Api as ApiIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
} from '@mui/icons-material';
import PageHeader from '../../../components/common/PageHeader';

const TIME_RANGES = [
  { value: 1, label: '1 Hour' },
  { value: 6, label: '6 Hours' },
  { value: 24, label: '24 Hours' },
  { value: 72, label: '3 Days' },
  { value: 168, label: '1 Week' },
];

const VIEW_OPTIONS = [
  { value: 'overview', label: 'Overview', icon: <DashboardIcon /> },
  { value: 'by-endpoint', label: 'By Endpoint', icon: <ApiIcon /> },
  { value: 'by-staff', label: 'By Staff', icon: <PeopleIcon /> },
  { value: 'by-department', label: 'By Department', icon: <BusinessIcon /> },
];

export default function ErrorDashboardHeader({
  onRefresh,
  onToggleFilters,
  onCleanup,
  loading = false,
  activeFiltersCount = 0,
  currentView = 'overview',
  onViewChange,
  timeRange = 24,
  onTimeRangeChange,
}) {

  return (
    <Box>
      {/* Main Header */}
      <PageHeader
        icon={BugReportIcon}
        title={'Error Monitoring'}
        subtitle={'Monitor and analyze system errors and exceptions'}
        actions={<>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="error-dashboard-header-select-label">Time Range</InputLabel>
            <Select labelId="error-dashboard-header-select-label"
              value={timeRange}
              label="Time Range"
              onChange={(e) => onTimeRangeChange(e.target.value)}
            >
              {TIME_RANGES.map((range) => (
                <MenuItem key={range.value} value={range.value}>
                  {range.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Tooltip title="Refresh Data">
            <IconButton onClick={onRefresh} disabled={loading}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Toggle Filters">
            <IconButton onClick={onToggleFilters}>
              <Badge badgeContent={activeFiltersCount || null} color="primary">
                <FilterIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip title="Cleanup Old Errors">
            <Button
              variant="outlined"
              startIcon={<CleanupIcon />}
              onClick={onCleanup}
              disabled={loading}
              color="warning"
            >
              Cleanup
            </Button>
          </Tooltip>
        </>}
      />

      {/* View Toggle */}
      <Box display="flex" alignItems="center" justifyContent="center" mb={3}>
        <ToggleButtonGroup
          value={currentView}
          exclusive
          onChange={(event, newView) => {
            if (newView !== null) {
              onViewChange(newView);
            }
          }}
          aria-label="error view selection"
          size="small"
        >
          {VIEW_OPTIONS.map((option) => (
            <ToggleButton
              key={option.value}
              value={option.value}
              aria-label={option.label}
              sx={{ px: 2 }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                {option.icon}
                <Typography variant="body2">{option.label}</Typography>
              </Box>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}